import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { ResourceAllocation } from "@app/enum/ResourceType";
import { ITag } from "@app/interfaces/ITag";
import { TagsService } from "@app/services/tags.service";
import { TranslationService } from "@app/services/translation.service";
import { VButtonDropdownComponent } from "@directives/_core/v-dropdown/v-button-dropdown/v-button-dropdown.component";
import { FilterBarComponent } from "../filter-bar.component";
import {  FilterTriggerType, IFilterBarFilter } from "../filter-bar.models";
import "./tag-button-filter.component.scss";

@Component({
    selector: "tag-button-filter",
    template: require("./tag-button-filter.component.html")
})
export class TagButtonFilterComponent implements IFilterBarFilter<ITag> {
    @Input() selected: ITag;
    @Input() label = this.translationService.t('tags.AllTags');
    @Output() change = new EventEmitter<ITag>();

    @ViewChild(VButtonDropdownComponent) dropdown: VButtonDropdownComponent;

    // ---

    name = this.translationService.t("tags.Tag");
    icon = "fa-solid fa-tag";
    type: FilterTriggerType = "tag";

    tags: ITag[];

    itemPromise: angular.IPromise<any>;

    resourceAllocation = ResourceAllocation;

    constructor(
        readonly parent: FilterBarComponent,
        readonly elementRef: ElementRef<HTMLElement>,
        private readonly tagsService: TagsService,
        private readonly translationService: TranslationService
    ) {

    }

    onFilterOpen(): void {
        this.itemPromise = this.tagsService.getTags().then(tags => {
            this.tags = tags;
        });
    }

    filterPredicate(item: any, value?: ITag): boolean {
        if (item.TagIds) {
            return item.TagIds.includes(value.Id);
        }

        if (item.vehicle) {
            return item.vehicle.TagIds?.includes(value.Id);
        }

        if (item.Vehicle) {
            return item.Vehicle.TagIds?.includes(value.Id);
        }

        if (item.driver) {
            return item.driver.TagIds?.includes(value.Id);
        }
        if (item.Driver) {
            return item.Driver.TagIds?.includes(value.Id);
        }

        return false;
    }

    searchPredicate = (item: ITag, value?: any): boolean => {
        return item.Name.toLowerCase().includes(value.toLowerCase());
    }

    onTagClick(tag: ITag): void {
        this.selected = tag;

        this.change.emit(tag);
        this.parent.onFilterChange("tag", tag);

        if (this.selected) {
            this.label = tag.Name;
        }
        else {
            this.label = this.translationService.t('tags.AllTags');
        }
    }

    clearSelectedTag(): void {
        this.onTagClick(null);
    }
}
